import React from "react";
import { Link, useNavigate } from "react-router-dom";
import providerRoutes from "../../../utlis/provider/routes.utlis.js";
import { routes } from "../../../utlis/user/routes.utlis";
import Header from "../../common/Header.js";
import Findcare1 from "../../../assets/images/findcare1.webp";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ProcessImage from "../../../assets/images/Process.webp";

const FindCare = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header></Header>
      <div className="care-slider-section">
        <div className="care-slider-item">
          <div className="care-slider-bg">
            <img
              src={Findcare1}
              alt="Care Exchange Blog Banner"
            />
          </div>
          <div className="care-slider-content-area">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="care-banner-circle">
                    <div className="care-slider-content">
                      <h1 className="care-slider-title">
                        Find Caregiver Jobs That Truly Value Your Expertise
                      </h1>
                      <h3 className="care-slider-subtitle">
                        Care-Exchange: The Easy, Safer, and Preferred Way for
                        Caregivers to Get Hired!
                      </h3>
                      <p className="care-slider-desc">
                        Join a trusted platform connecting caregivers with
                        flexible, verified, and rewarding job opportunities.
                        Build your profile, get matched instantly, and grow your
                        caregiving career with confidence.
                      </p>
                    </div>
                    <button
                      className="care-slider-btn"
                      style={{ border: "none" }}
                      type="button"
                      onClick={() => {
                        localStorage.setItem(
                          "findJobCare",
                          JSON.stringify({
                            lat: "",
                            lng: "",
                            address: "",
                            state: "",
                          })
                        );
                        navigate(routes.login);
                      }}
                    >
                      Start Today
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="whychoose-section">
        <div className="container">
          <div className="whychoose-page-heading">
            <h2>Why Choose Care-Exchange as a Caregiver</h2>
          </div>
          <div className="whychoose-page-content">
            <div className="row row-cols-xl-5 row-cols-xl-3 row-cols-md-2 g-1">
              <div className="col flex-fill">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.5 21C38.5 30.66 30.66 38.5 21 38.5C11.34 38.5 3.5 30.66 3.5 21C3.5 11.34 11.34 3.5 21 3.5C30.66 3.5 38.5 11.34 38.5 21Z"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M27.4925 26.5651L22.0675 23.3276C21.1225 22.7676 20.3525 21.4201 20.3525 20.3176V13.1426"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Flexible shifts & locations</h3>
                    <p>Choose a job as per your preference.</p>
                  </div>
                </div>
              </div>

              <div className="col flex-fill">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29.75 35.875H12.25C7 35.875 3.5 33.25 3.5 27.125V14.875C3.5 8.75 7 6.125 12.25 6.125H29.75C35 6.125 38.5 8.75 38.5 14.875V27.125C38.5 33.25 35 35.875 29.75 35.875Z"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 26.25C23.8995 26.25 26.25 23.8995 26.25 21C26.25 18.1005 23.8995 15.75 21 15.75C18.1005 15.75 15.75 18.1005 15.75 21C15.75 23.8995 18.1005 26.25 21 26.25Z"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.5 15.75H5.25C10.5 15.75 12.25 14 12.25 8.75V7"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M38.5 15.75H36.75C31.5 15.75 29.75 14 29.75 8.75V7"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.5 26.25H5.25C10.5 26.25 12.25 28 12.25 33.25V35"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M38.5 26.25H36.75C31.5 26.25 29.75 28 29.75 33.25V35"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Competitive pay</h3>
                    <p>Earn better pay with transparent payments.</p>
                  </div>
                </div>
              </div>

              <div className="col flex-fill">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M35.875 19.775V12.32C35.875 5.26751 34.23 3.5 27.615 3.5H14.385C7.77 3.5 6.125 5.26751 6.125 12.32V32.025C6.125 36.68 8.68002 37.7825 11.7775 34.4575L11.795 34.44C13.23 32.9175 15.4175 33.04 16.66 34.7025L18.4275 37.065"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M31.85 37.45C34.9428 37.45 37.45 34.9428 37.45 31.85C37.45 28.7572 34.9428 26.25 31.85 26.25C28.7572 26.25 26.25 28.7572 26.25 31.85C26.25 34.9428 28.7572 37.45 31.85 37.45Z"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M38.5 38.5L36.75 36.75"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14 12.25H28"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.75 19.25H26.25"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Relevant opportunities</h3>
                    <p>Get opportunities that fit your skills.</p>
                  </div>
                </div>
              </div>

              <div className="col flex-fill">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.3578 3.90297L9.62527 7.19297C7.61277 7.94547 5.96777 10.3255 5.96777 12.4605V25.463C5.96777 27.528 7.33277 30.2405 8.99527 31.483L16.5203 37.1005C18.9878 38.9555 23.0478 38.9555 25.5153 37.1005L33.0403 31.483C34.7028 30.2405 36.0678 27.528 36.0678 25.463V12.4605C36.0678 10.308 34.4228 7.92797 32.4103 7.17547L23.6778 3.90297C22.1903 3.36047 19.8103 3.36047 18.3578 3.90297Z"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.8379 20.7729L18.6554 23.5904L26.1804 16.0654"
                          stroke="#45B14A"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Safe & verified roles</h3>
                    <p>The platform is safe, secure, and transparent.</p>
                  </div>
                </div>
              </div>

              <div className="col flex-fill">
                <div className="whychoose-box">
                  <div className="whychoose-icon">
                    <div className="whychoose-icon-wrapper">
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M26.9327 9.1175L29.4001 14.0525C29.7326 14.735 30.6251 15.3825 31.3776 15.5225L35.8402 16.2575C38.6927 16.73 39.3577 18.795 37.3102 20.86L33.8276 24.3425C33.2501 24.92 32.9177 26.0575 33.1102 26.88L34.1076 31.185C34.8951 34.58 33.0752 35.91 30.0827 34.125L25.9001 31.64C25.1476 31.185 23.8877 31.185 23.1352 31.64L18.9526 34.125C15.9601 35.8925 14.1402 34.58 14.9277 31.185L15.9252 26.88C16.1177 26.075 15.7852 24.9375 15.2077 24.3425L11.7252 20.86C9.67768 18.8125 10.3427 16.7475 13.1952 16.2575L17.6577 15.5225C18.4102 15.4 19.3027 14.735 19.6352 14.0525L22.1027 9.1175C23.4152 6.44 25.5852 6.44 26.9327 9.1175Z"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14 8.75H3.5"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.75 33.25H3.5"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.25 21H3.5"
                          stroke="#1D364E"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="whychoose-head">
                    <h3>Build your reputation</h3>
                    <p> Collect good reviews to unlock more opportunities.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-5 p-4 lookingfor-care">
              <p className="lookingfor-care-lead fw-semibold ">
                Looking for senior care opportunities?
                <span className="d-block mt-1 fw-normal ">
                  Care-Exchange helps you find senior home care jobs near you.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="Process-section">
        <div className="container">
          <div className="Process-page-heading">
            <h2>How It Works</h2>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="Process-box">
                <div className="steps" role="list">
                  <div className="step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.41016 22C3.41016 18.13 7.26015 15 12.0002 15C12.9602 15 13.8902 15.13 14.7602 15.37"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22 18C22 18.32 21.96 18.63 21.88 18.93C21.79 19.33 21.63 19.72 21.42 20.06C20.73 21.22 19.46 22 18 22C16.97 22 16.04 21.61 15.34 20.97C15.04 20.71 14.78 20.4 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.92 14.43 15.93 15.13 15.21C15.86 14.46 16.88 14 18 14C19.18 14 20.25 14.51 20.97 15.33C21.61 16.04 22 16.98 22 18Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M19.4897 17.98H16.5098"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18 16.52V19.51"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Step 1: Create your profile</h3>
                      <p>
                        Add your experience, certifications, availability, and
                        care expertise so people can easily discover you.
                      </p>
                    </div>
                  </div>

                  <div className="step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M3.41016 22C3.41016 18.13 7.26015 15 12.0002 15C12.9602 15 13.8902 15.13 14.7602 15.37"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22 18C22 18.75 21.79 19.46 21.42 20.06C21.21 20.42 20.94 20.74 20.63 21C19.93 21.63 19.01 22 18 22C16.54 22 15.27 21.22 14.58 20.06C14.21 19.46 14 18.75 14 18C14 16.74 14.58 15.61 15.5 14.88C16.19 14.33 17.06 14 18 14C20.21 14 22 15.79 22 18Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.4399 18L17.4299 18.99L19.5599 17.02"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Step 2: Get matched & apply</h3>
                      <p>
                        Browse openings or wait for personalized invites that
                        fit your background- whether you want flexible shifts or
                        want to get senior caregiver jobs in your area.
                      </p>
                    </div>
                  </div>

                  <div className="step" role="listitem">
                    <div className="icon" aria-hidden="true">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.88 18.15V16.08"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M12 18.15V14.01"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M17.12 18.15V11.93"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M17.12 5.85L16.66 6.39C14.11 9.37 10.69 11.48 6.88 12.43"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M14.1899 5.85H17.1199V8.77"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          stroke="#292D32"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3>Step 3: Work & grow</h3>
                      <p>
                        Accept work, earn confidently, and collect reviews to
                        grow your profile and unlock more opportunities over
                        time.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="proeess-media">
                <img src={ProcessImage} alt="" />
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <Link to={routes.login} className="btn-gr">
              Create Your Caregiver Profile for Free
            </Link>
          </div>
        </div>
      </div>

      <div className="personalized-section">
        <div className="container">
          <div className="personalized-page-heading">
            <h2>Available Job Roles You Can Apply For</h2>
          </div>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            <div className="col">
              <div className="h-100  job-card">
                <h5>Nursing Assistant</h5>
                {/* <p>
                  Provide basic patient care and assistance with daily
                  activities.
                </p> */}
              </div>
            </div>

            <div className="col">
              <div className="h-100  job-card">
                <h5>Home Health Aide</h5>
                {/* <p>
                  Offer essential support and companionship in a client's home.
                </p> */}
              </div>
            </div>

            <div className="col">
              <div className="h-100  job-card">
                <h5>Medical Assistant</h5>
                {/* <p>
                  Perform clinical and administrative tasks in a healthcare
                  facility.
                </p> */}
              </div>
            </div>

            <div className="col">
              <div className="h-100  job-card">
                <h5>Licensed Practical/Vocational Nurse</h5>
                {/* <p>
                  Provide direct patient care under the supervision of an RN or
                  physician.
                </p> */}
              </div>
            </div>

            <div className="col">
              <div className="h-100  job-card">
                <h5>Registered Nurse</h5>
                {/* <p>
                  Assess patient health problems, educate, and provide care.
                </p> */}
              </div>
            </div>

            <div className="col">
              <div className="h-100  job-card">
                <h5>Nurse Practitioner</h5>
                {/* <p>Provide advanced practice nursing care and diagnosis.</p> */}
              </div>
            </div>
          </div>

          <div className="text-center p-4 bg-light rounded shadow-sm">
            <p className="lead-discover mb-0 text-secondary">
              You can also discover part-time caregiver jobs and flexible
              home-care shifts perfect for your schedule.
            </p>
          </div>
        </div>
      </div>

      <div className="testimonials-page-section">
        <div className="container">
          <div className="testimonials-page-heading">
            <h2>What Caregivers Say About Care-Exchange</h2>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="testimonials-page-card h-100">
                <p>
                  "I started getting job invites just two days after signing up.
                  The flexibility lets me work around my family schedule. Love
                  this platform!"
                </p>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="testimonials-page-card h-100">
                <p>
                  "The matching system saved me hours of searching. I now get
                  steady work that fits my experience perfectly."
                </p>
              </div>
            </div>

            <div className="col-lg-4 mb-4">
              <div className="testimonials-page-card h-100">
                <p>
                  "I’ve built a strong reputation through reviews. It helped me
                  secure more senior-care roles and earn better pay."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="faq-section">
        <div className="container">
          <div className="faq-page-heading">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="faq-page-accordion">
            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                How quickly can I receive job matches?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Most caregivers start receiving matches within 24-72 hours
                  after completing their profiles.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                Are all care jobs verified in Care-Exchange?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Yes. Every employer, family, and agency on Care-Exchange is
                  screened for safety.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                Does it cost anything to join Care-Exchange?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  No. Creating your caregiver profile and applying to jobs is
                  free.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                Can I find part-time or flexible shifts?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Yes! Care-Exchange makes it easy to discover part-time
                  caregiver jobs and short shifts.
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>

      <div className="post-job-section">
        <div className="container">
          <h5 className="fw-bold mb-3">
            Ready to Start Your Caregiving Journey?
          </h5>
          <p className="lead mb-4">
            Your Next Great Care Job Is Just a Click Away!
          </p>
          <Link to={providerRoutes.routes.providerRegister} className="btn-gr">
            Sign Up Now
          </Link>
        </div>
      </div>

      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FindCare;
